import React from 'react';

const Scoreboard = ({ teams, currentRound, currentTeam, totalRounds }) => {
  return (
    <div className="scoreboard">
      <h1>Subject: {teams[currentTeam].subject.toUpperCase()} Topic: {teams[currentTeam].topic.toUpperCase()} Quiz</h1>
      <div className="round-info">
        <p><strong>Current Player:</strong> {teams[currentTeam].kidName} <strong>Round:</strong> {currentRound} / {totalRounds}</p>
      </div>
      <div className="team-scores">
        {teams.map((team, index) => (
          <div key={index} className="team-score">
            <p> {team.name} - {team.kidName} - {team.grade}</p>
            <p className="score"><strong>Score:</strong> {team.score}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Scoreboard;